import { render, staticRenderFns } from "./NewPhysicalFranchiseSidebar.vue?vue&type=template&id=6ba4f3d7&scoped=true"
import script from "./NewPhysicalFranchiseSidebar.vue?vue&type=script&lang=js"
export * from "./NewPhysicalFranchiseSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewPhysicalFranchiseSidebar.vue?vue&type=style&index=0&id=6ba4f3d7&prod&lang=scss&scoped=true"
import style1 from "./NewPhysicalFranchiseSidebar.vue?vue&type=style&index=1&id=6ba4f3d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4f3d7",
  null
  
)

export default component.exports